import initTcoTool from './initTcoTool';

const tcoTools = document.querySelectorAll('.cms-content-slice__tco-tool');
tcoTools.forEach(tcoTool => {
    initTcoTool(tcoTool);
});